var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{attrs:{"id":_vm.id}},[_vm._v("\n    Your browser does not support the canvas element.\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }